module.exports = __webpack_public_path__ + "img/southkorea.653ded45.svg";